import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import $ from 'jquery';
import { PageChangedEvent } from '../../../utils/events/page-changed-event';
import { CommunicationService } from '../../../services/communication.service';
import { PageService } from '../../../services/page.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ApplicationStateService } from '../../../services/application-state.service';
import { JoinPipe } from '../../../pipes/join.pipe';

@Component({
    selector: 'app-page-switcher',
    templateUrl: './page-switcher.component.html',
    styleUrls: ['./page-switcher.component.scss'],
    standalone: true,
    imports: [
        JoinPipe
    ]
})
export class PageSwitcherComponent implements OnInit, OnDestroy {

    static IDS = 1;
    readonly ID_PREFIX = 'pageSwitcherInput';
    id: string;
    currentIndices: Array<number> | [string];
    pageSwitcherComponent: JQuery;
    pageAmount: number;

    private subscription: Subscription;

    constructor(public applicationStateService: ApplicationStateService,
                private communicationService: CommunicationService,
                private pageService: PageService,
                private deviceService: DeviceDetectorService) {
        PageSwitcherComponent.IDS++;
        this.id = this.ID_PREFIX + PageSwitcherComponent.IDS;
        this.subscription = this.communicationService.pageTurnConfirmed$.subscribe(pages => {
            this.updateCurrentIndicies();
        });
    }

    /**
     * Called after component creation.
     */
    ngOnInit(): void {
        this.pageAmount = this.pageService.getPageCount();
        this.updateCurrentIndicies();
    }

    /**
     * Called before component deletion.
     */
    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    /**
     * Handler for focus event on page indicator.
     *
     * @param {Event} $event
     */
    onFocus($event): void {
        this.getContainer().val('');
    }

    /**
     * Handle key down event on page indicator.
     * @param $event
     */
    onKeyDown($event): void {
        if (this.deviceService.getDeviceInfo().browser.includes('ie') && $event.which === 13) {
            this.changePage();
        }
    }

    /**
     * Handler for blur event on page indicator.
     *
     * @param {Event} $event
     */
    onBlur($event): void {
        this.updateCurrentIndicies();
        this.getContainer().val(this.currentIndices.join(' - '));
    }

    /**
     * Turn to next page.
     *
     * @param {Event} $event
     */
    nextPage($event): void {
        this.communicationService.announcePageTurn(PageChangedEvent.createTurnPageForwardEvent());
    }

    /**
     * Turn to previous page.
     *
     * @param {Event} $event
     */
    previousPage($event): void {
        this.communicationService.announcePageTurn(PageChangedEvent.createTurnPageBackwardsEvent());
    }

    /**
     * Turn page to a specific index.
     *
     * @param {Event} $event
     */
    changePage($event?): void {
        const inputValue = +this.getContainer().val();

        if (!isNaN(inputValue) && this.getContainer().val() !== '') {
            const pageChangedEvent = new PageChangedEvent();
            pageChangedEvent.moveToPage = this.pageService.getIndexFromPageNumber(inputValue);
            this.communicationService.announcePageTurn(pageChangedEvent);
        }

        if (this.deviceService.isMobile() || this.deviceService.isTablet()) {
            // Blur from input to prevent software keyboard to stay open on touch devices
            this.getContainer().blur();
        }
    }

    /**
     * Update the page indicator.
     */
    private updateCurrentIndicies(): void {
        if (this.getContainer().is(':focus')) {
            // Prevent updating text when input is focused
            return;
        }

        this.pageService.getCurrentRealPageNumbers().then(result => {
            this.currentIndices = result.filter(ele => ele > 0);
            if (!this.currentIndices.length) {
                this.currentIndices = ['-'];
            }
        });
    }

    private getContainer(): JQuery {
        if (!this.pageSwitcherComponent || this.pageSwitcherComponent.length <= 0) {
            this.pageSwitcherComponent = $(`#${this.id}`);
        }

        return this.pageSwitcherComponent;
    }

}
